module.exports = __webpack_public_path__ + "static/media/akacia-temnaya.0c5eedd1.jpg";